import { ref, type Ref } from 'vue'

export const productIdBus = ref<number>(0)
